import React from 'react'
import './about.css'
import ME from '../../assets/about-us.png'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'

const about = () => {
  const phrases = ["{About Us}", "{About Us} "]
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2><TextScrambler phrases={phrases} speed={5} pauseTime={1000}/></h2>

      <div className="container about__container">
        <div className="about__me">
          {/* <div className='test'></div> */}
          <div className="about__me-image">
            <img src={ME} alt="" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>4+ Years</small>
            </article>
            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Clients</h5>
              <small>120+ Client</small>
            </article>
            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>15+ Finished</small>
            </article>
          </div>

          <p>
            KH Development store is a store that offers you Everything you wish in FiveM, The store that includes a lot of professional programmers in the field of FiveM, the store aims to meet the needs of players in the field of FiveM.
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>

        </div>
      </div>
    </section>
  )
}

export default about